import styled, { css } from 'styled-components';
import { ReactComponent as Shield } from '../../../assets/img/shield.svg';
import { fontDisplay, fontUi } from '../../../theme/typography';

const ownWash = css`
  background: ${({ theme }) =>
    theme.isDark ? 'rgba(14, 74, 251, 0.24)' : 'rgba(14, 74, 251, 0.12)'};
`;

export const StyledGroupContainer = styled.div`
  display: flex;
  flex-direction: row;
  max-width: 220px;
  align-items: stretch;
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 8px;
  height: 44px;
  width: 100%;
  overflow: hidden;
  position: relative;
  background: ${({ theme }) => theme.hover};
  ${({ $own }) => $own && ownWash};
  ${({ side }) => {
    if (side === 'right') {
      return css`
        flex-direction: row-reverse;
      `;
    }
  }}
  ${({ shortVersion }) => {
    if (shortVersion) {
      return css`
        border: 0;
        background: transparent;
        max-width: 90px;
        margin-bottom: 0;
        overflow: visible;
        height: auto;
        align-items: center;
      `;
    }
  }}
`;
export const StyledName = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1;
  min-width: 0;
  ${fontUi};
  font-size: 13px;
  font-weight: 500;
  color: ${({ theme }) => theme.text};
  height: 100%;
  padding: 0 8px;
  cursor: pointer;
  img {
    max-width: 32px;
    max-height: 32px;
    width: 100%;
    height: 100%;
    object-fit: contain;
    flex-shrink: 0;
  }
  span {
    padding-left: 8px;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  ${({ shortVersion }) => {
    if (shortVersion) {
      return css`
        width: 45px;
        flex: none;
        padding: 0;
        background-color: transparent;
      `;
    }
  }}
`;
export const StyledGoals = styled.div`
  ${fontDisplay};
  width: 36px;
  flex-shrink: 0;
  height: 100%;
  background-color: ${({ theme }) => theme.inset};
  color: ${({ theme }) => theme.text};
  font-size: 13px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-left: 1px solid ${({ theme }) => theme.border};
  ${({ $pending, theme }) => {
    if ($pending) {
      return css`
        color: ${theme.textFaint};
        font-weight: 500;
      `;
    }
  }}
  ${({ side }) => {
    if (side === 'right') {
      return css`
        flex-direction: row-reverse;
        border-left: 0;
        border-right: 1px solid ${({ theme }) => theme.border};
      `;
    }
  }}
  ${({ shortVersion, theme }) => {
    if (shortVersion) {
      return css`
        margin-left: 8px;
        width: 24px;
        height: 24px;
        border: 1px solid ${theme.border};
        border-radius: 6px;
        background: ${theme.inset};
      `;
    }
  }}
`;

export const StyledNoWinner = styled(Shield)`
  width: 22px;
  flex-shrink: 0;
  path {
    fill: ${({ theme }) => theme.border};
  }
`;
